import {css} from 'lit';

import {defaultStyles} from '../../../components/switch.js';

export const styles = defaultStyles.extends({
  statics: css``,
  colorGen: () => '',
  gradientGen: () => '',
  sizeGen: () => '',
});

export default {styles};
